import { EPromoType, IPromoInfo } from '../../../types/newbuilding/promoInfo';

export const getAuthorLabel = (promo: IPromoInfo): string | null => {
  const isCianMortgage = promo.promoType === EPromoType.CianMortgage;

  if (isCianMortgage) {
    return null;
  }

  return promo.isFromBuilder ? 'Застройщик' : 'Представитель застройщика';
};
